import moment from 'moment-timezone';

export default class FormatHelper {
	static dateFormatPattern(dateTime, pattern) {
		if (dateTime === '' || dateTime === null || dateTime === undefined) {
			return 'N/A';
		} else {
			var dateStr = new Date(parseInt(dateTime));
			return moment(dateStr).format(pattern);
		}
	}
}
